import React, { Component } from 'react'
import styled from 'styled-components'
import Logic from './logic'
import FiltersData from './data'

/** UI */
import { Grid, Row, Col } from 'react-flexbox-grid'
import { ShadowBox } from '@ubiwherenpm/adene-ui-components'
import ArrowIcon from './images/ic-arrow.svg'
import DualSelect from 'components/DualSelect'
import Select from 'components/Select'

const gasFilters = ['price_step', 'municipality']
const eletricityFilters = ['potencia_contratada', 'ciclo_horario']

const GAS_OFFER_TYPE = 3
const ELECTRICTY_OFFER_TYPE = 2

@Logic
export default class Filters extends Component {
  /**
   * Verifies if the filter is currently disabled
   * Based on the field it is dependent on.
   */
  isFilterDisabled = ({ dependsOn, dependsMostBe }) => {
    return false
  }

  /**
   * Checks if user selected all the needed filters
   * to procced with the fetching
   */
  checkIfFlowIsFinished = () => {
    // if (filters.offer_type === undefined) {
    //   return false
    // }

    // // TODO: refactor this sometime soon
    // let neededFilters = ['no_contract_duration', 'billing']

    // if (filters.offer_type === EG_OFFER_TYPE) {
    //   neededFilters = [...neededFilters, ...eletricityFilters, ...gasFilters]
    // }

    // if (filters.offer_type === ELECTRICTY_OFFER_TYPE) {
    //   neededFilters = [...neededFilters, ...eletricityFilters]
    // }

    // if (filters.offer_type === GAS_OFFER_TYPE) {
    //   neededFilters = [...neededFilters, ...gasFilters]
    // }

    // for (var index = 0; index < neededFilters.length; index++) {
    //   var filter = neededFilters[index]
    //   if (filters[filter] === undefined) {
    //     return false
    //   }
    // }

    return true
  }

  /**
   * Adds the new filter to the state
   */
  setFilterAndCheckIfFinishFlow = (selected, item) => {
    // Remove filters if needed

    let filtersToRemove = []
    if (item.fieldName === 'offer_type') {
      if (selected.value === ELECTRICTY_OFFER_TYPE) {
        filtersToRemove = [...gasFilters]
      }
      if (selected.value === GAS_OFFER_TYPE) {
        filtersToRemove = [...eletricityFilters]
      }
      if (filtersToRemove.length) {
        this.actions.removeFilters(filtersToRemove)
      }
    }

    this.actions.setFilter(selected, item)

    // Wait for redux to finsh doing stuff
    setTimeout(() => {
      const isFlowFinished = this.checkIfFlowIsFinished()

      // Trigger fetching
      if (isFlowFinished) {
        this.actions.triggerFilter()
      }
    }, 0)
  }

  /**
   * Renders all the selects based on they type
   */
  renderSelects = ({ type, filters, disabled }) => {
    let WrapperSelect = SelectsContainer

    if (type === 'multifull') {
      WrapperSelect = MultiFullSelect
    }

    return (
      <WrapperSelect>
        {filters && filters.map(({ name, values, async, checkboxed, ...item }) => {
          let items = values
          let action

          if (async) {
            items = this.props[async.prop]
            action = this.actions[async.action]
          }

          // Easier fix for https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/32 #3
          let selected = this.props.filters[item.fieldName]

          if (item.fieldName === 'no_contract_duration') {
            if (selected === 'any') {
              selected = undefined
            }
          }

          return (
            name === 'Localização'
            ? <DualSelect
              key={name}
              placeholder={name}
              items={items}
              action={action}
              arrowIcon={ArrowIcon}
              onChange={(selected) => this.setFilterAndCheckIfFinishFlow(selected, item)}
              selected={this.props.filters[item.fieldName]}
              disabled={disabled}
              checkboxed={checkboxed}
              removedSelectOnSelected={item.removedSelectOnSelected}
            />
            : <FullSelect
              key={name}
              placeholder={name}
              items={items}
              action={action}
              arrowIcon={ArrowIcon}
              onChange={(selected) => this.setFilterAndCheckIfFinishFlow(selected, item)}
              selected={selected}
              disabled={disabled}
              checkboxed={checkboxed}
              removedSelectOnSelected={item.removedSelectOnSelected}
              excludeAllExceptOnSelect={item.excludeAllExceptOnSelect}
              />
          )
        })}
      </WrapperSelect>
    )
  }

  /**
   * Renders the filters boxes based on the json data
   */
  renderFilters = () => {
    return FiltersData &&
      FiltersData.map(({ name, size, icon, hidden, ...rest }) => {
        const disabled = this.isFilterDisabled({ ...rest })
        if (hidden) {
          return null
        }

        return (
          <Column md={size} key={name} disabled={disabled}>
            <Box><Icon src={icon} />{name}</Box>
            {this.renderSelects({ ...rest, disabled })}
          </Column>
        )
      }
    )
  }

  /** Lonely boy */
  render () {
    const { renderClose } = this.props
    return (
      <Wrapper>
        <Container fluid>
          <FiltersList>
            {this.renderFilters()}
            {renderClose()}
          </FiltersList>
        </Container>
      </Wrapper>
    )
  }
}

const Wrapper = styled(ShadowBox)`
  height: 150px;
  width: 100%;
  position: relative;
  top: -75px;
  display: flex;
  margin-bottom: -75px;
`

const FiltersList = styled(Row)`
  margin: 0 !important;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  height: 100%;
`

const Container = styled(Grid)`
  padding-left: 0!important;
  padding-right: 0!important;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
`

const Box = styled(Col)`
  text-align: center;
  height:48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #EFEFEF;
  text-transform: uppercase;
  flex: 1;
`

const Column = styled(Col)`
  padding: 0!important;
  flex-direction: column;

  ${(props) => props.disabled && `
    opacity: .4;
    pointer-events: none;
  `}
`

const FullSelect = styled(Select)`
  flex: 1;
  text-align: left;
  max-width: initial;
  > div:first-child {
    height: 100%;
    border-bottom: 0;
    border-right: 0;
  }
`

const MultiFullSelect = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 48px);
`

const Icon = styled.img`
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
`

const SelectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 48px);
`



// WEBPACK FOOTER //
// ./src/containers/Filters/index.js